function escapeCsv(value) {
  const text = value == null ? "" : String(value);
  const needsQuotes = /[",\n\r]/.test(text);
  const escaped = text.replace(/"/g, '""');
  return needsQuotes ? `"${escaped}"` : escaped;
}

function escapeHtml(value) {
  const text = value == null ? "" : String(value);
  return text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

function downloadBlob(filename, content, type) {
  const blob = new Blob([content], { type });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export function downloadCsv(filename, rows, columns) {
  const header = columns.map((c) => escapeCsv(c.label)).join(",");
  const lines = rows.map((row) => columns.map((c) => escapeCsv(row?.[c.key] ?? "")).join(","));
  const content = [header, ...lines].join("\r\n");
  downloadBlob(filename, content, "text/csv;charset=utf-8");
}

export function downloadExcelHtml(filename, rows, columns) {
  const headerCells = columns.map((c) => `<th>${escapeHtml(c.label)}</th>`).join("");
  const bodyRows = rows
    .map((row) => {
      const cells = columns.map((c) => `<td>${escapeHtml(row?.[c.key] ?? "")}</td>`).join("");
      return `<tr>${cells}</tr>`;
    })
    .join("");

  const html = `<!DOCTYPE html>
<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
  <head>
    <meta charset="utf-8" />
    <meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8" />
  </head>
  <body>
    <table>
      <thead><tr>${headerCells}</tr></thead>
      <tbody>${bodyRows}</tbody>
    </table>
  </body>
</html>`;

  downloadBlob(filename, html, "application/vnd.ms-excel;charset=utf-8");
}

